import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {LoginFormComponent} from "./login/login-form/login-form.component";
import {SignupFormComponent} from "./login/signup-form/signup-form.component";
import {ResetFormComponent} from "./login/reset-form/reset-form.component";
import {NotFoundComponent} from "./not-found/not-found.component";
import {LoginComponent} from "./login/login.component";
import {VisitorGuard} from "../core/guards/visitor.guard";
import {PasswordComponent} from "./login/password/password.component";


let routes: Routes = [
  {path: 'notfound', component: NotFoundComponent},
  /*{path: 'login', redirectTo:'/login/signin', pathMatch: 'full' },*/
  {path: 'login', component: LoginComponent, canActivate: [VisitorGuard],
    children: [
      {path: 'signin', component: LoginFormComponent},
      {path: 'signup', component: SignupFormComponent},
      {path: 'forgot', component: ResetFormComponent},
      {path: 'password/:token', component: PasswordComponent}, // changer le mot de passe
    ]
  },
  {path: '**', component: NotFoundComponent}
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ]
})
export class SharedRoutingModule { }
